// A floater is a coverage for a specific items
// User can add a coverage to an item that exceeds default limit
export class Floater {
  type: FloaterType;
  value: number;
}

export enum FloaterType {
  Animal = 'animal',
  Art = 'art',
  Bicycle = 'bicycle',
  Watercraft = 'watercraft',
  Collection = 'collection',
  Fur = 'fur',
  Jewelry = 'jewelry',
  Tractor = 'tractor',
}
